function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1381_1023)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.24984 6.66663C6.47996 6.66663 6.6665 6.48008 6.6665 6.24996C6.6665 6.01984 6.47996 5.83329 6.24984 5.83329C6.01972 5.83329 5.83317 6.01984 5.83317 6.24996C5.83317 6.48008 6.01972 6.66663 6.24984 6.66663Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4882 2.15496C10.1757 1.84238 9.75183 1.66672 9.30984 1.66663H3.33317C2.89114 1.66663 2.46722 1.84222 2.15466 2.15478C1.8421 2.46734 1.6665 2.89127 1.6665 3.33329V9.30996C1.6666 9.75195 1.84225 10.1758 2.15484 10.4883L9.40817 17.7416C9.78693 18.118 10.2992 18.3292 10.8332 18.3292C11.3671 18.3292 11.8794 18.118 12.2582 17.7416L17.7415 12.2583C18.1179 11.8795 18.3291 11.3673 18.3291 10.8333C18.3291 10.2993 18.1179 9.78705 17.7415 9.40829L10.4882 2.15496Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24984 6.66663C6.47996 6.66663 6.6665 6.48008 6.6665 6.24996C6.6665 6.01984 6.47996 5.83329 6.24984 5.83329C6.01972 5.83329 5.83317 6.01984 5.83317 6.24996C5.83317 6.48008 6.01972 6.66663 6.24984 6.66663Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1381_1023"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.52015ec5.svg";
export { ForwardRef as ReactComponent };